import React from "react";
import { FirmSection } from "./FirmSection";
import { PagesSection } from "./PagesSection";
import { LeadsSection } from "./LeadsSection";
import { DeliverySection } from "./DeliverySection";
import { ThankYouSection } from "./ThankYouSection";
import { TestimonialsSection } from "./TestimonialsSection";
import { TermsSection } from "./TermsSection";

export const OnboardingForm = ({ a, set, ro, admin, price, priceEdit, terms, logo }) => {
  const p = { a, set, ro };
  return (
    <div className="space-y-6" data-testid="onboarding-form">
      <FirmSection {...p} />
      <PagesSection {...p} logo={logo} />
      <LeadsSection {...p} price={price} priceEdit={priceEdit} />
      <DeliverySection {...p} admin={admin} />
      <ThankYouSection {...p} />
      <TestimonialsSection {...p} />
      <TermsSection {...p} terms={terms} admin={admin} />
    </div>
  );
};

export const Missing = ({ items, title = "Still needed", testId = "ob-missing" }) => (!items?.length ? null : (
  <div className="border-2 border-amber-600 bg-amber-50 p-4 text-sm" data-testid={testId}>
    <div className="label-mono text-amber-900 mb-1">{title}</div>
    <ul className="list-disc pl-5 space-y-0.5 text-amber-950">{items.map((m) => <li key={m}>{m}</li>)}</ul>
  </div>
));

export const useAnswerSetter = (setA, onChange) => (k, v) => {
  setA((prev) => ({ ...prev, [k]: v }));
  if (onChange) onChange();
};
